'use client'

import { UnstyledButton } from '@mantine/core'
import { faMessage } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { showRefinerForm } from './refiner'
import styles from './RefinerFeedbackButton.module.css'

export interface RefinerFeedbackButtonProps {
  /** ID of the Refiner survey whose trigger is set to "Manual". */
  formId: string
  label?: string
}

/**
 * Opens a Refiner survey on click. Refiner has no built-in feedback tab, so this
 * stands in for the Appzi one; the survey itself must use the Manual trigger
 * with Recurrence set to "On Each Trigger Event" so it can be opened repeatedly.
 *
 * Internal to `RefinerLoader`, which mounts it only once the app has identified
 * the user, since `showForm` needs an identified user. Deliberately not exported
 * from the package barrel.
 */
export default function RefinerFeedbackButton({ formId, label = 'Feedback' }: RefinerFeedbackButtonProps) {
  return (
    <UnstyledButton type="button" className={styles.tab} onClick={() => showRefinerForm(formId)}>
      <span className={styles.label}>
        <FontAwesomeIcon icon={faMessage} className={styles.icon} />
        {label}
      </span>
    </UnstyledButton>
  )
}
